import { Component, State, Element, Listen, h } from '@stencil/core';
import { AlertSeverity } from '../../public-interfaces';
import { Alert } from '../../public-interfaces';
import { wait } from '../../utils/utils';

const IconMap = {
  [AlertSeverity.Success]: 'assets/alert-box/Success.svg',
  [AlertSeverity.Error]: 'assets/alert-box/Error.svg',
};

/**
 * @internal
 */
@Component({
  tag: 'alert-box',
  styleUrl: 'alert-box.css',
  shadow: true,
})
export class AlertBox {
  /**
   * Alert severity
   */
  @State() severity: AlertSeverity = AlertSeverity.Success;
  /**
   * Message to display
   */
  @State() message: string = '';
  @State() timeoutMS: number = 1000;
  @State() timeoutId: NodeJS.Timeout = null;
  @State() timeoutIsActive: boolean = false;
  @Element() el: HTMLElement;

  @Listen('alertEmitter', { target: 'window' })
  async newAlertHandler(event: CustomEvent<Alert>) {
    const alertBox = this.el.shadowRoot.getElementById('alertBox');
    if (this.timeoutIsActive) {
      clearTimeout(this.timeoutId);
      alertBox.style.animation = `slideOut 250ms ease-in forwards`;
      await wait(250);
    } else {
      this.timeoutIsActive = true;
    }

    this.severity = event.detail.severity;
    this.message = event.detail.message;
    this.timeoutMS = event.detail.timeoutMS;

    alertBox.style.animation = `slideIn 250ms ease-in forwards`;
    this.timeoutIsActive = true;
    this.timeoutId = setTimeout(() => {
      alertBox.style.animation = `slideOut 250ms ease-in forwards`;
      this.timeoutIsActive = false;
    }, this.timeoutMS);
  }

  componentDidLoad() {
    const alertBox = this.el.shadowRoot.getElementById('alertBox');
    alertBox.style.setProperty('--animTimeout', `${this.timeoutMS}ms`);
  }

  render() {
    return (
      <div
        id="alertBox"
        style={{
          backgroundColor: `var(--${this.severity}-bg)`,
        }}
      >
        <img src={IconMap[this.severity]}></img>
        <p
          style={{
            color: `var(--${this.severity}-fill)`,
          }}
        >
          {this.message}
        </p>
      </div>
    );
  }
}
